import React from 'react';
import { Code, Shield, Server, Link2 } from 'lucide-react';
import { useAppContext } from '../context/AppContext';
import { t } from '../i18n';

const ApiDocumentation = () => {
  const { apiEndpoints } = useAppContext();

  return (
    <div className="space-y-6">
      <div className="bg-white border border-neutral-200 rounded p-6">
        <div className="flex items-center gap-3">
          <Code className="w-6 h-6 text-neutral-400" />
          <div>
            <h1 className="text-xl font-semibold text-neutral-900">{t('API REST · Integraciones externas')}</h1>
            <p className="text-sm text-neutral-500">{t(
              'Endpoints diseñados para interoperar con SAP, Power BI y otras plataformas analíticas.'
            )}</p>
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-3 mt-5 text-sm text-neutral-600">
          <div className="bg-neutral-50 border border-neutral-200 rounded p-3">
            <p className="font-semibold text-neutral-800">{t('URL Base')}</p>
            <p>https://api.alcorprocurement.com/v1</p>
          </div>
          <div className="bg-neutral-50 border border-neutral-200 rounded p-3">
            <p className="font-semibold text-neutral-800">{t('Autenticación')}</p>
            <p>{t('Bearer Token (OAuth 2.0 Client Credentials)')}</p>
          </div>
          <div className="bg-neutral-50 border border-neutral-200 rounded p-3">
            <p className="font-semibold text-neutral-800">{t('Formato')}</p>
            <p>{t('JSON · UTF-8')}</p>
          </div>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {apiEndpoints.map((endpoint) => (
          <div
            key={endpoint.id}
            className="bg-white border border-neutral-200 rounded p-4 flex flex-col gap-3"
          >
            <div className="flex items-center gap-3">
              <Server className="w-5 h-5 text-neutral-400" />
              <div>
                <h3 className="text-sm font-semibold text-neutral-900">{t(endpoint.name)}</h3>
                <p className="text-xs font-medium text-neutral-500">{t(endpoint.method)} {t(endpoint.route)}</p>
              </div>
            </div>
            <p className="text-sm text-neutral-500">{t(endpoint.description)}</p>
            <div className="bg-neutral-50 border border-neutral-200 rounded p-3 text-xs text-neutral-500">
              <p className="font-semibold text-neutral-600 uppercase">{t('Ejemplo de request')}</p>
              <pre className="mt-2 whitespace-pre-wrap">
{`curl -X ${endpoint.method} "https://api.alcorprocurement.com/v1${endpoint.route.replace(':id', '123')}" \\
  -H "Authorization: Bearer <TOKEN>" \\
  -H "Content-Type: application/json"`}
              </pre>
            </div>
          </div>
        ))}
      </div>

      <div className="bg-white border border-neutral-200 rounded p-6 space-y-3">
        <div className="flex items-center gap-3">
          <Shield className="w-4 h-4 text-neutral-500" />
          <h2 className="text-sm font-semibold text-neutral-900">{t('Buenas prácticas de seguridad e integración')}</h2>
        </div>
        <ul className="list-disc list-inside text-sm text-neutral-600 space-y-1.5">
          <li>{t(
            'Emplea scopes diferenciados para lectura y escritura (`orders:read`, `orders:approve`).'
          )}</li>
          <li>{t(
            'Implementa webhooks de `inventory.movement` para sincronizar trazabilidad con Power BI.'
          )}</li>
          <li>{t(
            'Configura `ETag` y cabeceras `If-Modified-Since` para optimizar consultas periódicas.'
          )}</li>
          <li>{t(
            'Los endpoints de SAP consumen payloads en JSON, con claves en notación `snake_case`.'
          )}</li>
        </ul>
        <div className="flex items-start gap-2 text-xs text-neutral-500">
          <Link2 className="w-4 h-4 mt-0.5" />
          <p>{t(
            'Documentación ampliada y contratos de servicio disponibles en el portal de desarrolladores: developers.alcorprocurement.com'
          )}</p>
        </div>
      </div>
    </div>
  );
};

export default ApiDocumentation;
